import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
    selector: 'admin-users-settings-page',
    templateUrl: './admin-users-settings.component.html',
    styleUrls: ['./admin-users-settings.component.scss'],
    standalone: false
})
export class AdminUsersSettingsComponent implements OnInit
{
  data;
    constructor(private http: HttpClient)
    {
    }

  ngOnInit()
  {
  }
}
